const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import PeopleGrid from "./layouts/people_grid";
import Featherlight from "./../lib/featherlight";
import Cookies from 'js-cookie';
import PieChartCounter from "./components/PieChartCounter.class";
import Hubspot from "./Hubspot.class";
import Complianz from "./Complianz.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #TabsLayout;
    #PeopleGrid;
    #slider;
    #utils;
    #$admin;
    #root;
    #hubspot;
    #cmp;

    #counter;

    constructor(
        config,
        builder,
        utils,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#inPageNav = new InPageNav(this);
        this.#TabsLayout = new TabsLayout(this);
        this.#PeopleGrid = new PeopleGrid(this);
        this.#cmp = new Complianz(this, this.$body, () => {
            return typeof cmplz_has_consent === "function";
        });

        this.#hubspot = new Hubspot("7852770", this.#cmp);
        new PieChartCounter(this);
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        me.#TabsLayout.events();
        me.#PeopleGrid.events();
        me.#slider.setup();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "navbars": [
                    {
                        "position": "top",
                        "content": [
                            "searchfield"
                        ]
                    }
                ],
                "extensions": [
                    "pagedim-black",
                    "theme-light",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                offCanvas: {
                    pageNodetype: 'div#page.site-wrapper'
                },
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": this.#config.homeURL
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );

        $(".laptop-preview__preview").hover(function () {
            $(this).parents(".laptop-preview").find(".laptop-preview__bg").addClass("js-hovered");
        }, function () {
            $(this).parents(".laptop-preview").find(".laptop-preview__bg").removeClass("js-hovered");
        });

        $(".laptop-preview__thumbnail--panMode").on("mousemove", function (e) {
            const $img = $(this);
            const $parent = $img.parents(".laptop-preview");
            const offset = $img.offset();
            const width = $img.width();
            const height = $img.height();
            const x = ((e.pageX - offset.left) / width) * 100;
            const y = ((e.pageY - offset.top) / height) * 100;
            $parent[0].style.setProperty('--x', `${x}%`);
            $parent[0].style.setProperty('--y', `${y}%`);
        });

        $(".logo-slider-container").each(function (e) {
            const $el = $(this);
            const $innerEl = $el.children().first();
            const direction = $innerEl.data("direction") === 'left' ? 'true' : '';
            const uid = $innerEl.data("uid");
            $el.height($innerEl.height());

            $(`#logoSlider-${uid}`).cycle({
                fx: "carousel",
                timeout: 1,
                easing: "linear",
                reverse: direction,
                slides: "> .slide",

                paused: false
            }).css("width", "auto").removeClass("loading");

            $el.height("auto");

        })
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        me.#slider.show();

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.carouselSpotlight__slide', '.carouselSpotlight');
        // Utils.equalHeight('.quoteSlider__slide', '.quoteSlider');
        Utils.equalHeight('.tabbed_section__js', '.tabbed_section');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');
        Utils.equalHeight('.kpfsc__post', '.kpfsc__posts');

        this.#TabsLayout.init();

        this.$header.addClass('fixed');
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
            $(window).trigger("resize");
        }, 1000);

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: time,
                        easing: 'linear',
                        step: function () {
                            $me.text(Utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(Utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $('.single_accordion .single_accordion__header').on('click', function () {
            const $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        function toggleAccordion($accordion) {
            const $dropdown = $accordion.next('.sub-menu');

            // Standardize display state to account for initial open menus.
            if ($accordion.hasClass('js-open')) {
                $dropdown.css('display', 'block');
            } else {
                $dropdown.css('display', 'none');
            }

            $accordion.toggleClass('js-open');
            $dropdown.slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        }

        $('.menu-elements__menu-accordion > .accordionItem').on('click', function () {

            const $accordion = $(this);
            const $menu = $accordion.parents("ul.menu > li > .sub-menu");
            const $column = $accordion.closest(".menu-elements__column");

            const height = Number($menu.css('min-height').replace("px", ""));
            if (height < $menu.height()) {
                $menu.css('min-height', $menu.height());
            }

            $accordion.addClass('js-active');

            toggleAccordion($accordion);

            $column.find('.menu-elements__menu-accordion > .accordionItem:not(.js-active).js-open').each(function (i, el) {
                toggleAccordion($(el));
            });

            $accordion.removeClass('js-active');
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
        Utils.equalHeight('.kpfsc__post', '.kpfsc__posts');
    }

    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");

        kpf.$el.parent().filter(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />'
            const $leftArrow = '<i class="fa fas fa-chevron-left" />'
            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: true,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        kpf.addFilter("select2_options", function (options) {
            options.dropdownParent = $(".main-wrapper");

            return options;
        });
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    get CMP() {
        return this.#cmp;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}